export const levelAnswer = value => value?.kind === 'level' ? `Level ${value.level}` : 'Cannot assess'
